import classNames from 'classnames';
import { CreateInitiative } from './CreateInitiative';
import { getInitiativeRoute } from '@lib/routes';
import { PopoverSelector } from '@ui/PopoverSelector';
import { useInitiatives } from '@hooks';
import { FULL_ROUTES, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
export const InitiativeSelector = ({ children, className, onDeselect, onOpenChange, onSelect, selectedIds = [], singleSelect, trigger = 'hover' }) => {
    const { data, request } = useInitiatives();
    return (React.createElement(PopoverSelector, { className: classNames('initiative-picker', className), footer: React.createElement(CreateInitiative, { onFinish: (response) => onSelect({
                id: response.initiativeId,
                title: response.initiativeTitle
            }), source: 'card' }), itemRender: ({ title }) => title, listItems: data.results, manageRoute: FULL_ROUTES.INITIATIVES, onDeselect: onDeselect, onOpen: (initiativeId) => {
            window.open(`${window.location.origin}${getInitiativeRoute(initiativeId)}`, '_blank');
        }, onOpenChange: onOpenChange, onSearch: (value) => {
            request(Object.assign(Object.assign({}, useInitiatives.defaultRequest), { title: value }));
        }, onSelect: onSelect, placeholder: PLACEHOLDERS_COPY.SEARCH_INITIATIVES, selectedIds: selectedIds, singleSelect: singleSelect, trigger: trigger }, children));
};
